<template>
  <ModalDialog :closeable="$t('common.close')" :open.sync="IsOpen" size='large'>
    <p v-html="$t('meter-box.maximumPowerGuaranteed.explanation')"></p>
    <div class="lib__table-container lib__table-container--responsive">
      <table class="lib__table">
        <thead>
          <tr>
            <th>{{ $t('meter-box.maximumPowerGuaranteed.package') }}</th>
            <th>{{ $t('meter.maximumPowerGuaranteed') }}</th>
          </tr>
        </thead>
        <tbody>
          <template v-for="pack in meterElectricityPackages">
            <tr>
              <td :data-table-header="$t('meter-box.maximumPowerGuaranteed.package')">
                <label class="lib__field__label">{{ pack.key }}</label>
              </td>
              <td :data-table-header="$t('meter.maximumPowerGuaranteed')">
                <span class="lib__text-secondary lib__text-weight-700">
                  {{ pack.maximumPower.kiloVoltAmpere }} {{ $t('energyProduction.kva') }}
                </span>
              </td>
            </tr>
          </template>
        </tbody>
      </table>
    </div>
    <p>{{ $t('meter-box.maximumPowerGuaranteed.warning') }}</p>
  </ModalDialog>
</template>

<script lang="ts">
import { PackageDTO } from '@/models/customer-forms-api/index'
import { Vue, Component, Prop } from 'vue-property-decorator'
import { State } from 'vuex-class'

@Component
export default class GuaranteedMaximumPowerModal extends Vue {
  //#region [Property]
  @Prop({ type: Boolean, required: true })
  public readonly value!: boolean
  //#endregion

  //#region [Data]
  @State('meterElectricityPackages', { namespace: 'newConnectionCmh/cmhEnergyConfiguration' })
  public meterElectricityPackages!: PackageDTO[]
  //#endregion

  //#region [Computed]
  public get IsOpen(): boolean {
    return this.value
  }

  public set IsOpen(val: boolean) {
    this.$emit('input', val)
  }
  //#endregion
}
</script>
